const listStyle = {
  root: {
    backgroundColor: '#FAFAFA',
  },
};

export { listStyle };
